import { render } from "./ProductSpecification.vue?vue&type=template&id=1da10ae0&scoped=true"
import script from "./ProductSpecification.vue?vue&type=script&lang=js"
export * from "./ProductSpecification.vue?vue&type=script&lang=js"

import "./ProductSpecification.vue?vue&type=style&index=0&id=1da10ae0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da10ae0"]])

export default __exports__